const NextCircled = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.741 14.414a.48.48 0 0 1-.356.144.49.49 0 0 1-.356-.144c-.096-.096-.144-.715-.144-.356V9.942q0-.212.143-.356a.48.48 0 0 1 .356-.144q.212 0 .357.144a.48.48 0 0 1 .144.356v4.116c0-.359-.048.26-.144.356M15.96 12.51l-2.9 1.927a.55.55 0 0 1-.622.036.58.58 0 0 1-.322-.546v-3.854a.58.58 0 0 1 .322-.546.55.55 0 0 1 .621.037l2.9 1.927a.59.59 0 0 1 .274.511.58.58 0 0 1-.274.507"
    />
  </>
)
export default NextCircled
